import _get from 'lodash/get';
import _set from 'lodash/set';
import { ISession } from '../types';

/**
 * Extends a session with additional properties
 */
export default function extendSessionProperties(session: ISession) {
  /* istanbul ignore next */
  if (!_get(session, 'user.profile.name')) {
    // TODO: Session provided full-name.
    _set(session, 'user.profile.name', session.username);
  }

  return session;
}
